// extracted by mini-css-extract-plugin
export default {"popover":"Tooltip_popover__+vJ33","tooltip":"Tooltip_tooltip__17kOo","arrow":"Tooltip_arrow__x9HaB"};